import React, { Component } from "react";
import styles from "../../assets/css/modules/help/help-section.css";
import Accordion from "../shared/Accordion";
import Content from "../../content/Content";
import printStyle from "../../assets/css/modules/print.css";

export default class HelpSectionCancer extends Component {
  render() {
    return (
      <div
        className={`help-section ${styles.sectionSpacing}`}
        role="region"
        aria-label="help"
      >
          <div
            className={styles.HelpLink + " " + printStyle.noprint}
          >
             {this.props.HeadingLinkText} {"        "}
             <i className="icon-info" style={{fontSize: "15pt"}}/>
              
          </div>
        <div className={styles.w65Responsive + " " + styles.accordionWrapper}>
          {this.props.HelpSet &&
            this.props.HelpSet.map((qnAnswerItem, index) => (
              <Content
                key={index}
                names={[qnAnswerItem.Answer, qnAnswerItem.Question]}
              >
                {(answer, question) => (
                  <Accordion question={question} answer={answer} />
                )}
              </Content>
            ))}
        </div>
      </div>
    );
  }
}
